import * as THREE from 'three'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import RoundedPlane from '../misc/RoundedPlane'
import MovableObject from '../misc/MovableObject'
import { TWEEN } from 'three/examples/jsm/libs/tween.module.min'
import Icon from '../misc/Icon'
import Label from '../misc/Label'
import { subscribers } from '../Store'
import { get } from 'svelte/store'
import { appPrimaryColor } from '../Store'

const gltfLoader = new GLTFLoader()

export default class CityScene extends THREE.Object3D {
    constructor(controls, scene) {
        super()
        this.scene = scene
        this.create()
        this.controls = controls
        const scale = 0.0025
        this.scale.set(scale, scale, scale)
        this.position.set(0, 0, 0)
        this.rotation.set(0, Math.PI / 4, 0)
        this.doners = []
    }

    async create() {
        const model = await this.loadCityModel()
        model.position.set(0, 0, 0)

        this.loadDropZones(model)
        await this.loadDoners()
        this.loadIcons()
        this.add(model)
        this.dispatchEvent({ type: 'loaded' })
    }

    async loadCityModel() {
        const cityGltf = await gltfLoader.loadAsync('https://pivotal-5g-webxr.s3.amazonaws.com/assets/City.glb')
        const model = cityGltf.scene

        model.traverse(function (child) {
            if (child.isMesh) {
                child.castShadow = false;
                child.receiveShadow = false;
                child.material.metalness = 0.5
            }
        });
        console.log(model)

        return model
    }


    loadDropZones(model) {
        const poleOne = this.loadDropZone(model.children.find(v => v.name === "pole002"), true)
        const poleTwo = this.loadDropZone(model.children.find(v => v.name === "pole003"), true)
        const poleThree = this.loadDropZone(model.children.find(v => v.name === "pole004"), true)

        const dropZoneOne = this.loadDropZone(model.children.find(v => v.name === "Pole005"), false, { x: -30, y: 50, z: 50 }, new THREE.Vector3(-100, -3000, -100)) //top left
        const dropZoneTwo = this.loadDropZone(model.children.find(v => v.name === "Pole001"), false, { x: 25, y: 50, z: 0 }, new THREE.Vector3(-100, -3000, 100)) //bottom left
        const dropZoneThree = this.loadDropZone(model.children.find(v => v.name === "Pole002"), false, { x: 0, y: 50, z: -50 }, new THREE.Vector3(100, -3000, 100)) //bootom right

        this.add(poleOne) //should connect 1 & 3
        this.add(poleTwo) //should connect 3
        this.add(poleThree) //should connect 2

        this.add(dropZoneOne)
        this.add(dropZoneTwo)
        this.add(dropZoneThree)

        dropZoneOne.connections = [poleOne]
        dropZoneTwo.connections = [poleThree]
        dropZoneThree.connections = [poleTwo]

        this.dropZones = [dropZoneOne, dropZoneTwo, dropZoneThree]
        this.poles = [poleOne, poleTwo, poleThree]
    }

    loadDropZone(child, isActive, offset, lightRotation) {
        const zone = new DropZone({ isActive, offset, lightRotation })
        zone.position.set(0, 2, 0)
        zone.position.x = child.position.x
        zone.position.z = child.position.z
        zone.position.y = 2
        return zone
    }

    async loadDoners() {
        for (let index = 0; index < 3; index++) {
            const donerGltf = await gltfLoader.loadAsync('https://pivotal-5g-webxr.s3.amazonaws.com/assets/doner_white_small.glb')
            const model = donerGltf.scene

            model.traverse(function (child) {
                if (child.isMesh) {
                    child.castShadow = true;
                    child.receiveShadow = false;
                }
            });
            const movableDoner = new MovableObject(this.controls)
            movableDoner.add(model)
            movableDoner.scale.set(0.1, 0.1, 0.1)
            movableDoner.position.set(-0.5 + index * 0.5, 1.5, -1)
            this.controls.scene.add(movableDoner)
            for (const zone of this.dropZones) {
                zone.hoverObjects = [...zone.hoverObjects, movableDoner]
            }
            movableDoner.destination = this.dropZones[index]
            this.doners = [...this.doners, movableDoner]
        }
    }

    async loadIcons() {
        const playButton = new Icon(this.controls, { src: 'https://pivotal-5g-webxr.s3.amazonaws.com/assets/Play.png', color: 'white', height: 0.15, width: 0.15 })
        const rewindButton = new Icon(this.controls, { src: 'https://pivotal-5g-webxr.s3.amazonaws.com/assets/Rewind.png', color: 'white', height: 0.15, width: 0.15 })

        this.controls.scene.add(playButton)
        this.controls.scene.add(rewindButton)

        const label = new Label('#cityScene', 0.25, 0.5)
        subscribers.subscribe(subscribers => {
            console.log({ v: subscribers })
            try {
                setTimeout(() => {
                    label.update()
                }, 50)
            } catch (e) {
                console.log(e)
            }
        })
        this.controls.scene.add(label)

        label.position.set(0.25, 1, -1.5)
        rewindButton.position.set(0.1, 0.35, -0.5)
        playButton.position.set(0.35, 0.35, -0.5)



        playButton.addEventListener('click', () => {
            resetIcons()
            playButton.setColor(appPrimaryColor)
            this.play()
            setTimeout(resetIcons, 1000)
        })
        rewindButton.addEventListener('click', () => {
            resetIcons()
            rewindButton.setColor(appPrimaryColor)
            this.reset()
            setTimeout(() => {
                this.reset()
                resetIcons()
            }, 200)
        })

        const resetIcons = () => {
            playButton.setColor('white')
            rewindButton.setColor('white')
        }
    }

    play() {
        this.reset()
        this.reset()
        for (const doner of this.doners) {
            console.log('play', doner)
            new TWEEN.Tween(doner.position)
                .to(
                    {
                        x: doner.destination.worldP.x,
                        y: doner.destination.worldP.y,
                        z: doner.destination.worldP.z,
                    },
                    500
                )
                .start()
        }
    }

    reset() {
        subscribers.set(0)
        for (let index = 0; index < this.doners.length; index++) {
            const doner = this.doners[index]
            doner.visible = true
            doner.scale.set(0.1, 0.1, 0.1)
            doner.rotation.set(0, 0, 0)
            doner.position.set(-0.5 + index * 0.5, 1.5, -1)
        }

        for (const zone of this.dropZones) {
            zone.reset()
            if (!zone.initiallyActive) {
                zone.isActive = false
            }
        }

        for (const pole of this.poles) {
            pole.reset()
        }
    }
}

class DropZone extends THREE.Object3D {
    constructor({ isActive, offset, lightRotation }) {
        super()
        this.isActive = isActive
        this.initiallyActive = isActive

        const plane = new RoundedPlane({ height: 30, width: 30, radius: 15, opacity: 0.7, color: this.initiallyActive ? 'yellow' : 'rgb(255,80,35)' })
        plane.rotation.set(Math.PI / 2, 0, 0)

        this.boundsRaycaster = new THREE.Raycaster()
        this.boundsRaycaster.far = 0.25
        this.worldP = new THREE.Vector3()
        this.boundsDirection = new THREE.Vector3(0, 1, 0)
        this.plane = plane
        this.hoverObjects = []
        this.offset = offset
        this.lightRotation = lightRotation
        this.add(plane)
        if (!isActive) this.loadSpotLights()
        this.drawnFrom = []
    }

    async loadSpotLights() {
        const light = new THREE.SpotLight('rgb(255,80,35)')
        const targetObject = new THREE.Object3D();
        targetObject.position.set(this.offset.x, this.offset.y, this.offset.z)
        light.intensity = 0
        light.distance = 0.45
        light.angle = 1.25
        light.position.set(0, 0, 0)
        light.decay = 3
        light.penumbra = 0
        light.target = targetObject

        const helper = new THREE.SpotLightHelper(light);
        this.add(targetObject)
        // this.add(helper)
        this.add(light)
        this.light = light
    }

    tick() {
        try {
            if (!this.isActive) {
                this.checkForIntersects()
                this.light.intensity = 0
            }
        } catch (e) {
            console.log(e)
        }

        try {
            if (this.lines)
                for (const line of this.lines) {
                    const points = [];
                    points.push(this.connections[0].position);
                    points.push(line.linePositionObject.position);
                    line.geometry.setFromPoints(points);
                }
        } catch (e) {
            console.log(e)
        }
    }

    checkForIntersects() {
        this.getWorldPosition(this.worldP)
        for (const object of this.hoverObjects) {
            if (!object) return
            this.boundsRaycaster.set(
                this.worldP,
                this.boundsDirection,
            )
            const intersects = this.boundsRaycaster.intersectObject(object, true)
            if (intersects.length > 0) {
                this.activate()
                this.lockObject(object)
            }
        }
    }

    lockObject(mesh) {
        mesh.moving = false
        new TWEEN.Tween(mesh.position)
            .to(
                {
                    x: this.worldP.x,
                    y: this.worldP.y,
                    z: this.worldP.z,
                },
                1000
            )
            .start()
        new TWEEN.Tween(mesh.scale)
            .to(new THREE.Vector3(0, 0, 0), 1000)
            .easing(TWEEN.Easing.Cubic.InOut)
            .start();

        setTimeout(() => {
            mesh.visible = false
        }, 500)
    }

    activate() {
        const currentSubscribers = get(subscribers)
        const newSubscribers = 159 + currentSubscribers
        subscribers.set(newSubscribers)
        this.isActive = true
        if (!this.connections) return
        setTimeout(() => {
            this.illuminate()
        }, 1000)
        this.loadLines()
    }

    reset() {
        this.drawnFrom = []
        try {
            for (const child of this.parent.children) {
                if (child.name === 'connection-line') {
                    child.removeFromParent()
                    child.dispose()
                }
            }
        } catch (e) {
            console.log(e)
        }

        try {
            this.light.intensity = 0
        } catch (e) {
            console.log(e)
        }
    }

    illuminate() {
        this.light.intensity = 5
    }

    loadLines() {
        let lines = []
        const material = new THREE.LineDashedMaterial({
            color: 'yellow',
            linewidth: 5,
            scale: 1,
            dashSize: 10,
            gapSize: 5,
        });
        for (const child of this.connections) {
            if (this.drawnFrom.includes(child.uuid)) {

            } else if (child.drawnFrom.includes(this.uuid)) {

            } else {
                this.drawnFrom = [...this.drawnFrom, child.uuid]
                child.drawnFrom = [...child.drawnFrom, this.uuid]
                const points = [];
                points.push(this.position);
                points.push(child.position);
                const linePositionObject = new THREE.Object3D()
                this.parent.add(linePositionObject)
                linePositionObject.position.set(child.position.x, child.position.y, child.position.z)

                new TWEEN.Tween(linePositionObject.position)
                    .to(
                        {
                            x: this.position.x,
                            y: this.position.y,
                            z: this.position.z,
                        },
                        1000
                    )
                    .start()

                const geometry = new THREE.BufferGeometry().setFromPoints(points);
                const line = new THREE.Line(geometry, material);
                line.linePositionObject = linePositionObject
                line.computeLineDistances();
                line.scale.set(1, 1, 1);
                line.name = 'connection-line'
                this.parent.add(line);
                line.child = child
                lines.push(line)
            }
        }
        this.lines = lines
    }


    setColor(color) {
        try {
            const mesh = this.plane
            const material = mesh.material
            material.color = new THREE.Color(color);
        } catch (e) {
            console.log(e)
        }
    }
}